module.exports = __webpack_public_path__ + "img/web.d3cd9218.svg";